module.exports = __webpack_public_path__ + "img/logo-VAM.3a7effa7.svg";